import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Form, FormControl, Button, Image, OverlayTrigger, Col } from 'react-bootstrap'
import UploadImage from '../presentational-components/UploadImage';
import { updateArticleTypeInputs } from '../../store/actions/index'
import { FetchUpdateArticle } from '../../fetcher';

const DetailedArticleType = ({ dispatch, sizeCat, articleDetail, handleCloseArticle, openAlert }) => {
    let name
    let articleNumber
    let gender
    let style
    let price

    const [filename, setFilename] = useState("")
    const [image, setImage] = useState("")

    //const handleInput = () => {
    //    dispatch(updateArticleTypeInputs(articleNumber.value, name.value, gender.value, style.value, price.value, sizeCat))
    //}

    const handleSubmit = (e) => {
        e.preventDefault()

        //const isValid = true
        //dispatch(updateArticleTypeInputs(articleNumber.value, name.value, gender.value, style.value, price.value, sizeCat, isValid))

        const articleToUpdate = {
            Name: name.value,
            ArticleNumberDesigner: articleNumber.value,
            DescriptionDesigner: style.value,
            Gender: gender.value,
            SizeCat: sizeCat,
            Price: price.value,
            LabelArticleTypeId: articleDetail.ArticleTypeSysId
        }
        FetchUpdateArticle(articleToUpdate, handleCloseArticle, openAlert)
    }

    return (
        <div lang="de">
            <Form onSubmit={handleSubmit} id='update-article-form'>
                <Form.Group controlId="article-select">

                    <div className="controlTitle">Artikelnummer:</div>
                    <FormControl required className="form" as="input" defaultValue={articleDetail.ArticleNumberDesigner} ref={node => articleNumber = node}></FormControl>

                    <div className="controlTitle">Größenkategorie:</div>
                    <FormControl disabled as="select" className="form"
                        focusFirstItemOnShow='keyboard' >
                        <option>{sizeCat}</option>
                    </FormControl>

                    <div className="controlTitle">Name:</div>
                    <FormControl required className="form" as="input" defaultValue={articleDetail.Name} ref={node => name = node}></FormControl>

                    <div className="controlTitle">Geschlecht:</div>
                    <FormControl disabled as="select" defaultValue={articleDetail.Sexes} className="form"
                        focusFirstItemOnShow='keyboard' ref={node => gender = node}>
                        <option disabled value={articleDetail.Sexes}>{articleDetail.Sexes}</option>
                    </FormControl>

                    <div className="controlTitle">Beschreibung:</div>
                    <FormControl required className="form" as="textarea" defaultValue={articleDetail.DescriptionDesigner} ref={node => style = node} ></FormControl>

                    <div className="controlTitle">Preis:</div>
                    <Form.Row size="sm" className="input-currency">
                        <Col><FormControl required className="form" type="number" min="0.00" step="0.01" defaultValue={articleDetail.Price} ref={node => price = node}></FormControl> </Col>
                        <Col> <p className="input-currency-symbol">€</p> </Col>
                    </Form.Row>

                    <Form inline>
                            <Image className="thumbnail" src={articleDetail.articleImage} />
                    </Form>

                    {/*<UploadImage setFilename={setFilename} setImage={setImage} />*/}

                </Form.Group>
            </Form>
        </div>
    );
}

const mapStateToProps = (state) => ({
    articleDetails: state.inventory
})

export default connect(mapStateToProps)(DetailedArticleType)